import React from 'react'
import clsx from 'clsx'
import { TextareaAutosize } from '@mui/material'

import OverflowTooltip from '../../../atoms/OverflowTooltip'
import FieldCopy from '../FieldCopy'

import useStyles from '../styles'

const MultilineInput = ({
  field,
  value,
  disabled,
  canEdit,
  handleChange,
  handleBlur,
  timelineMode,
  task,
  inputOnly,
  row,
  rowKey,
  parent,
  inTable
}) => {
  const [startingValue, setStartingValue] = React.useState('')
  const [hovering, setHovering] = React.useState(false)

  //timelineMode is variant for autosize
  const classes = useStyles({
    readOnly: disabled,
    timelineMode,
    task,
    inputOnly,
    inTable
  })

  return (
    <div
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      className={clsx(classes.fieldInputRoot, 'cf-input-root')}
    >
      {!inputOnly && (
        <OverflowTooltip
          text={field.description}
          className={clsx(
            classes.label,
            classes.alignBaseline,
            classes.multilineLabel,
            'label'
          )}
        >
          {field.title}
        </OverflowTooltip>
      )}

      <FieldCopy inTable={inTable} visible={hovering} text={value} />

      <TextareaAutosize
        placeholder={canEdit ? 'Type...' : 'None'}
        value={value}
        onChange={e => handleChange(e, field, row, rowKey, parent)}
        onFocus={() => setStartingValue(value)}
        onBlur={e => {
          if (e.target.value !== startingValue) {
            handleBlur && handleBlur()
          }
        }}
        disabled={disabled || !canEdit}
        className={clsx(classes.input, classes.multilineInput)}
        style={{
          cursor: disabled ? 'not-allowed' : 'auto'
        }}
        maxRows={4}
        minRows={1}
      />
    </div>
  )
}

export default MultilineInput
